import ImageItem from "rlink-media/ImageItem";

export default class CityGalleryImage extends ImageItem {
  get adminLabel() {
    return this.title.length > 0 ? this.title : "<untitled city gallery image>";
  }

  get mainImageFormats() {
    return {
      src: this.imagePath,
      formats: [
        { contentType: "image/webp", fileExt: "webp" },
        { contentType: "image/jpeg", fileExt: "jpg" },
      ],
      widths: [1920, 1440, 1024, 750],
    };
  }

  get title () {
    return this.data.get('title', '');
  }

  get subtitle () {
    return this.data.get('subtitle', '');
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content-types/CityGalleryImage.js